import ProfileButton from './ProfileButton.vue';

export default ProfileButton;



// WEBPACK FOOTER //
// ./src/pages/profile/profilemenu/components/button/index.ts